import { render, staticRenderFns } from "./ProjectsShow.vue?vue&type=template&id=b453c80a&scoped=true&"
import script from "./ProjectsShow.vue?vue&type=script&lang=js&"
export * from "./ProjectsShow.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsShow.vue?vue&type=style&index=0&id=b453c80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b453c80a",
  null
  
)

export default component.exports